module.exports = __webpack_public_path__ + "img/Uganda.7706946e.gif";